import { AuthorizationForm } from './Authorization';

export default AuthorizationForm;